(() => {
  const snapToIndex = (track, index) => {
    const children = [...track.children];
    const target = children[index];
    if (!target) return;
    track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  };

  document.querySelectorAll('[data-ph-media-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-ph-media-track]');
    if (!track || track.children.length < 2) return;
    const prev = slider.querySelector('[data-ph-media-prev]');
    const next = slider.querySelector('[data-ph-media-next]');
    const slides = [...track.children];
    const title = slider.querySelector('[data-ph-media-title]');
    const text = slider.querySelector('[data-ph-media-text]');
    let index = 0;
    const setCopy = () => {
      const slide = slides[index];
      if (title && slide?.dataset.phMediaTitle) title.textContent = slide.dataset.phMediaTitle;
      if (text && slide?.dataset.phMediaText) text.textContent = slide.dataset.phMediaText;
    };
    const update = (direction) => {
      index = (index + direction + slides.length) % slides.length;
      setCopy();
      snapToIndex(track, index);
    };
    prev?.addEventListener('click', () => update(-1));
    next?.addEventListener('click', () => update(1));
    track.addEventListener('scroll', () => {
      const nextIndex = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (nextIndex !== index && slides[nextIndex]) {
        index = nextIndex;
        setCopy();
      }
    }, { passive: true });
  });

  document.querySelectorAll('[data-ph-feature]').forEach((slider) => {
    const track = slider.querySelector('[data-ph-feature-track]');
    const dots = [...slider.querySelectorAll('[data-ph-feature-dot]')];
    if (!track || dots.length === 0) return;
    let index = 0;
    let timer;

    const setActive = (nextIndex, shouldScroll = true) => {
      index = (nextIndex + dots.length) % dots.length;
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false'));
      if (shouldScroll) snapToIndex(track, index);
    };

    const start = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = window.setInterval(() => setActive(index + 1), 5200);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        stop();
        setActive(Number(dot.dataset.phFeatureDot || 0));
        start();
      });
    });

    track.addEventListener('scroll', () => {
      const nextIndex = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (nextIndex !== index) setActive(nextIndex, false);
    }, { passive: true });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    start();
  });

  document.querySelectorAll('[data-ph-anatomy]').forEach((root) => {
    const title = root.querySelector('[data-ph-anatomy-title]');
    const text = root.querySelector('[data-ph-anatomy-text]');
    const hotspots = [...root.querySelectorAll('.ph-lp-anatomy__hotspot')];
    hotspots.forEach((hotspot) => {
      hotspot.addEventListener('click', () => {
        if (title) title.textContent = hotspot.dataset.title || '';
        if (text) text.textContent = hotspot.dataset.text || '';
        hotspots.forEach((item) => item.setAttribute('aria-expanded', item === hotspot ? 'true' : 'false'));
      });
    });
  });
})();
